import { Component } from '@angular/core';

/**
 * NoPermissionPage.Component
 */
@Component({
  selector: 'app-no-permission',
  templateUrl: './no-permission-page.component.html',
  styleUrls: ['./no-permission-page.component.scss']
})
export class NoPermissionPageComponent {}
